import React from 'react';
import {Link} from 'react-router';
import {useTheme} from '@components/theme/useTheme';
import {useTranslation} from 'react-i18next';

interface LogoProps {
    className?: string;
    forceDarkMobile?: boolean;
}

const Logo = (props: LogoProps) => {
    const {t} = useTranslation();
    const theme: 'light' | 'dark' = useTheme();
    const {className, forceDarkMobile} = props;
    const mobileLogoTheme = forceDarkMobile ? 'dark' : theme;

    const logoSrc =
        theme === 'dark'
            ? '/build/images/logo_dark.svg'
            : '/build/images/logo.svg';

    const faviconSrc =
        mobileLogoTheme === 'dark'
            ? '/build/images/favicon_dark.svg'
            : '/build/images/favicon.svg';

    return (
        <Link
            to="/"
            className={`mr-4 block h-[30px] py-[5px] text-xl leading-5 site-lg:h-10 site-lg:leading-[30px] ${className ?? ''}`}>
            <img
                src={logoSrc}
                width="130px"
                className="d-none d-lg-inline-block hidden site-lg:inline-block"
                alt={t('common.site_logo')}
            />
            <img
                src={faviconSrc}
                width="20px"
                className="d-sm-inline-block d-lg-none inline-block site-lg:hidden"
                alt={t('common.site_icon')}
            />
        </Link>
    );
};

export default Logo;
